function OrganizationAddress() {
    "use strict";
    this.__type = 'OrganizationAddress:www.veritracks.com';
    this.Id = -1;
    this.OrganizationId = -1;
    this.OrganizationAddressTypeId = -1;
    this.Title = "";
    this.Notes = "";
    this.PhoneNumber = "";
    this.Street1 = "";
    this.Street2 = "";
    this.City = "";
    this.State = "";
    this.Country = "";
    this.Zip = "";
    this.Latitude = 0;
    this.Longitude = 0;
    this.Radius = 0;
    this.IsActive = 0;
    this.PositionMatchesGeoCode = -1;
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
}
if (typeof exports !== 'undefined') {
    module.exports = OrganizationAddress;
}